module.exports = __webpack_public_path__ + "img/code.835b992e.webp";